import actionTypes from 'constants/eventbriteConstants';
import { change } from 'redux-form';
import Cookies from 'js-cookie';

const EVENTBRITE_TOKEN_FIELD = 'evvntEventbriteAccessToken';
const EVENTBRITE_REDIRECT_FIELD = 'evventEventbriteRedirectTo';

export const authorizeEventbrite = () => dispatch => {
  Cookies.set(EVENTBRITE_REDIRECT_FIELD, window.location.href);
  const authUrl = `https://www.eventbrite.com/oauth/authorize?response_type=token&client_id=${EVENTBRITE_KEY}`;
  if (inIframe) {
    window.open(authUrl);
  } else {
    window.location = authUrl;
  }
};

export const disconnectEventbrite = () => dispatch => {
  Cookies.remove(EVENTBRITE_TOKEN_FIELD);
  dispatch({ type: actionTypes.EVENTBRITE_DISCONNECTED });
};

export const getAvailableEvebriteEvents = () => (dispatch, getState, api) => {
  dispatch({ type: actionTypes.FETCH_EVENTBRITE_EVENTS_REQUEST });

  const token = Cookies.get(EVENTBRITE_TOKEN_FIELD);
  api.post('eventbrite/events', { token }).then(
    result => dispatch({ type: actionTypes.FETCH_EVENTBRITE_EVENTS_SUCCESS, payload: result.data }),
    error => dispatch({ type: actionTypes.FETCH_EVENTBRITE_EVENTS_FAILURE, payload: error })
  );
};

export const importEventbriteData = id => (dispatch, getState, api) => {
  dispatch({ type: actionTypes.FETCH_EVENTBRITE_EVENT_REQUEST });

  const token = Cookies.get(EVENTBRITE_TOKEN_FIELD);
  api.post(`eventbrite/events/${id}`, { token }).then(
    result => dispatch({ type: actionTypes.FETCH_EVENTBRITE_EVENT_SUCCESS, payload: result.data }),
    error => dispatch({ type: actionTypes.FETCH_EVENTBRITE_EVENT_FAILURE, payload: error })
  );
};

function getTokenFromLocationHash(dispatch) {
  if (window.location.hash.indexOf('access_token') > -1) {
    const token = window.location.hash.substring(1).split('=').pop();
    if (token.length > 0) {
      window.location.hash = '';
      Cookies.set(EVENTBRITE_TOKEN_FIELD, token);
      dispatch(change('eventSubmission', 'use_eventbrite', true));
    }
    return token;
  } else {
    return null;
  }
}

function inIframe () {
  try {
    return window.self !== window.top;
  } catch (e) {
    return true;
  }
}

function getErrorFromLocation() {
  if (window.location.search.indexOf('error') > -1) {
    return window.location.search.split('=').pop();
  } else {
    return null;
  }
}

export function initializeEventbrite() {
  return (dispatch) => {
    dispatch({ type: actionTypes.EVENTBRITE_INITIALIZE });
    let currentToken = null;
    if (window.location.hash.length > 0 && window.location.hash.indexOf('access_token') > -1) {
      currentToken = getTokenFromLocationHash(dispatch);
    } else {
      currentToken = Cookies.get(EVENTBRITE_TOKEN_FIELD);
    }

    if (currentToken === null || currentToken === undefined) {
      dispatch({ type: actionTypes.EVENTBRITE_UNAUTHORIZED, payload: getErrorFromLocation() });
    } else {
      dispatch(checkEventbriteToken(currentToken));
      const redirectTo = Cookies.get(EVENTBRITE_REDIRECT_FIELD);
      if (redirectTo) {
        let shouldReload = false;
        if (redirectTo.split('#')[0] === window.location.href.split('#')[0]) {
          shouldReload = true;
        }
        dispatch({ type: actionTypes.EVENTBRITE_REDIRECTING });
        Cookies.remove(EVENTBRITE_REDIRECT_FIELD);
        window.location = redirectTo;
        if (shouldReload) {
          window.location.reload();
        }
      }
    }
  };
}

export function checkEventbriteToken(token) {
  return (dispatch, getState, api) => {
    api.post('eventbrite/validate_token', { token }).then(
      result => dispatch({ type: actionTypes.EVENTBRITE_AUTHORIZED, payload: result.data }),
      error => dispatch({ type: actionTypes.EVENTBRITE_UNAUTHORIZED, payload: error })
    );
  };
}



// WEBPACK FOOTER //
// app/client/bundles/EventSubmission/actions/eventbriteActions.js